import { combineReducers } from 'redux';
import { auth } from './reducers/auth';
import { unenrolledStudent } from './reducers/unenrolledStudent'
import { unenrolledStudentSelectedInfo } from './reducers/unenrolledStudentSelectedInfo'
import { selectedPeriodInfo } from './reducers/selectedPeriodInfo'
import { uiReducer } from './reducers/uiReducer'
import { exportDocumentReducer } from './reducers/exportDocumentReducer'
import { majorsReducer } from './reducers/majorsReducer'
import { periodsReducer } from './reducers/periodsReducer'
import { candidatesListReducer } from './reducers/candidatesListReducer';

const rootReducer = combineReducers(
    {
        auth,
        unenrolledStudent,
        unenrolledStudentSelectedInfo,
        uiReducer,
        exportDocumentReducer,
        majorsReducer,
        periodsReducer,
        candidatesListReducer,
        selectedPeriodInfo
    }
)

export default rootReducer;